import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH, REGEX_PATTERNS } from "@duosoftbg/nacid-components";

export const createFeedbackValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    name: yup
      .string()
      .required()
      .max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid"))
      .matches(REGEX_PATTERNS.NAME_VALIDATION_REGEX, i18n.t("validation.field.invalid")),
    text: yup
      .string()
      .required()
      .max(INPUT_LENGTH.MAX_INPUT_LENGTH_XL, i18n.t("validation.feedback.charCount.invalid")),
    file: yup.object({
      fileId: yup.string().required(i18n.t("validation.attachment.file.required")),
    }),
  });
};
